import ls from "@/plugins/secureLs";
import api from "../clients/axios";

const resource = "users";

export default {
  async getMyInfo() {
    const response = await api.get(`${resource}/me`);
    return response.data;
  },
  async getAllMyInfo() {
    const response = await api.get(`${resource}/me/complete`);
    return response.data;
  },
  async createAccount(body) {
    const response = await api.post(`${resource}/admin/register`, body);
    return response.data;
  },
  async createUser(body) {
    const response = await api.post(`${resource}/register`, body);
    return response.data;
  },
  async createMagayaUser(body) {
    const response = await api.post(`${resource}/magaya/register`, body, {
      headers: {
        token: "54dccb3747b693e185543f550a2dd280",
      },
    });
    return response.data;
  },
  async forgotPassword(body) {
    const response = await api.post(`${resource}/forgot-password`, body);
    return response.data;
  },
  async recoveryPassword(data) {
    const response = await api.post(`${resource}/recovery-password`, data.body, {
      params: data.params,
    });
    return response.data;
  },
  async validateIfTheEmailExist(data) {
    const response = await api.get(`${resource}/username`, {
      params: {
        username: data.username
      },
    });
    return response.data;
  },
  async getUsers() {
    const response = await api.get(`${resource}`);
    return response.data;
  },
  async getAllUsers(params) {
    const response = await api.get(`${resource}`, { params });
    return response.data;
  },
  async bulkDeactivateUsers(ids) {
    const response = await api.patch(`${resource}/bulk`, { ids });
    return response.data;
  },
  async bulkActivateUsers(ids) {
    const response = await api.patch(`${resource}/bulk/activate`, { ids });
    return response.data;
  },
  async bulkDeleteUsers(ids) {
    const response = await api.delete(`${resource}/bulk`, { data: { ids } });
    return response.data;
  },
  async updateUserInfo(data) {
    const response = await api.patch(`${resource}/${data.id}`, data.body);
    return response.data;
  },
  async updateUserTour(data) {
    const response = await api.patch(`${resource}/user-tour`, null, {
      params: { section_name: data },
    });
    return response.data;
  },
  async deleteUser(id) {
    const response = await api.delete(`${resource}/${id}`);
    return response.data;
  },

  downloadUsersSSE(params) {
    return new Promise((resolve, reject) => {
      const token = ls.get("portal-front-token");
      const baseURL = `${process.env.VUE_APP_BACK_ROUTE}/api/${resource}/export`;

      const queryParams = new URLSearchParams();
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== "") {
            queryParams.append(key, value);
          }
        });
      }
      const url = queryParams.toString() ? `${baseURL}?${queryParams}` : baseURL;

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            reject(new Error(`HTTP error: ${response.status}`));
            return;
          }
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let fullBuffer = "";

          try {
            // eslint-disable-next-line no-constant-condition
            while (true) {
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read();
              if (value) {
                fullBuffer += decoder.decode(value, { stream: !done });
              }
              if (done) break;
            }

            const trimmed = fullBuffer.trim();
            let accumulatedData = [];

            if (trimmed.startsWith("[")) {
              // Handle one or multiple concatenated arrays: [...][...]  →  [..., ...]
              const normalized = trimmed.replace(/\]\s*\[/g, ",");
              const parsed = JSON.parse(normalized);
              accumulatedData = Array.isArray(parsed) ? parsed : [];
            } else if (trimmed.startsWith("{")) {
              const parsed = JSON.parse(trimmed);
              accumulatedData = parsed.users || parsed.data || parsed.results || parsed.items || [];
            }

            resolve(accumulatedData);
          } catch (streamError) {
            reject(streamError);
          }
        })
        .catch(reject);
    });
  },
};
